import {Title} from '@angular/platform-browser';
import {Component, Inject, OnInit, Renderer2} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {ConfigurationService} from './services/configuration.service';
import {CustomSiteService} from "./services/customsite.service";
import {DOCUMENT} from '@angular/common';
// declare ga as a function to set and sent the events to google analytics
declare let ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title: string;
  agencia: number;
  showChat = false;
  chat = false;
  chatSrc = "https://webchat.botframework.com/embed/sptrans?s=ht2XQESr49M.ui1C9JVFHI-r9kTaSKZ8EBvLVhi0KmkMLMtusRit5_4"

  constructor(
    private router: Router,
    private titleService: Title,
    private configService: ConfigurationService,
    private customSiteService : CustomSiteService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
    ) {
      this.onConfigLoad = this.onConfigLoad.bind( this );
      configService.loadConfigurations().subscribe( this.onConfigLoad );
    }

    ngOnInit() {
      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          ga('set', 'page', evt.urlAfterRedirects);
          ga('send', 'pageview');
        }

        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });


      if (this.agencia == 435){
        this.createAndInsertSPTransFacebookChat();
      }
    }

    onConfigLoad( config ) {
      this.title = config.title;
      this.titleService.setTitle( this.title );
      this.agencia = config.agencyId
      localStorage.setItem('agency', this.agencia.toString());
    }

    createAndInsertSPTransFacebookChat(){
      let script = this._renderer2.createElement('script');
      script.text = `
      window.fbAsyncInit = function() {
        FB.init({
          xfbml            : true,
          version          : 'v9.0'
        });
      };

      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/pt_BR/sdk/xfbml.customerchat.js';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      `;

      this._renderer2.insertBefore(this._document.body, script, this._document.body.firstChild);


      let scriptSdk = this._renderer2.createElement('script');
      this._renderer2.setProperty(scriptSdk, 'id', 'facebook-jssdk');
      this._renderer2.setAttribute(scriptSdk, 'src', 'https://connect.facebook.net/pt_BR/sdk/xfbml.customerchat.js');
      this._renderer2.insertBefore(this._document.body, scriptSdk, this._document.body.firstChild);

      let div2 = this._renderer2.createElement('div');
      this._renderer2.setAttribute(div2, 'class', 'fb-customerchat');
      this._renderer2.setAttribute(div2, 'attribution', 'setup_tool');
      this._renderer2.setAttribute(div2, 'page_id', '584686444917050');
      this._renderer2.setAttribute(div2, 'logged_in_greeting', 'Como podemos ajudar?');
      this._renderer2.setAttribute(div2, 'logged_out_greeting', 'Como podemos ajudar?');
      this._renderer2.insertBefore(this._document.body, div2, this._document.body.firstChild);

      let div = this._renderer2.createElement('div');
      this._renderer2.setProperty(div, 'id', 'fb-root');
      this._renderer2.insertBefore(this._document.body, div, this._document.body.firstChild);
    }
  }
